import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class SetInvoicesPaymentDateBulkDto {
  @Expose()
  invoiceIds: string[];

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  paymentDate: Date;
}
